<template lang="pug">
  .customers
    h1 客户支持
    p.text 全方位覆盖各种不同类型用户需求
    div
      .customer(v-for="item in customers")
        div
          img(:src="item.img")
        h3.title {{ item.title }}
        p.text {{ item.text }}
</template>

<script>
  export default {
    name: "customers",
    props: {customers: Array},
    data() {
      return {};
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .customers {
    VStack(center)
    padding 50px 0
    .text {
      margin-top 14px
      margin-bottom 60px
    }
    > div {
      max-width 1200px
      width 60%
      background white
      box-shadow 0 10px 50px rgba(0, 0, 0, 5%)
      border-radius 6px
      HStack(center, space-around)
      
      .customer {
        VStack(center)
        padding 50px 0 60px
        .title {
          font-size 24px
          FontSetting("思源黑体")
          font-weight 400
          margin-bottom 0
          color #202020
        }
        > .text {
          text-align center
          FontSetting("思源黑体 CN Normal")
          font-size 16px
          line-height 24px
          color #666
        }
      }
    }
    @media (max-width ipadProScreenWidth) {
      > div {
        width 90%
      }
    }
    @media (max-width screenWidth) {
      width 100vw
      padding 50px 0 0
      h1 {
        margin-bottom 20px
      }
      > .text {
        margin-bottom 40px
        margin-top -20px
      }
      > div {
        width 100%
        VStack(center)
        .customer {
          padding 20px 0
          img {
            width 100px
          }
          .text {
            margin-bottom 0
            margin-top 0
          }
          .title {
            font-size 20px
            font-weight 300
            margin-top 0
          }
        }
      }
    }
  }
</style>
